import { useRef, useState } from "react";

/* Swipe-right-to-close for right-side drawers (phone).
   Activates only on horizontally-dominant right swipes; ignores gestures that
   start inside the chart or any horizontally-scrolling table so their own
   pan/scroll keeps working. Returns a live X offset for drag feedback. */
export function useSwipeClose(onClose) {
  const start = useRef(null);
  const [dx, setDx] = useState(0);
  const onTouchStart = (e) => {
    if (e.touches.length !== 1) { start.current = null; return; }
    const t = e.target;
    if (t.closest && t.closest("[data-noswipe], .tl-table-wrap, .stocks-table-wrapper")) { start.current = null; return; }
    start.current = { x: e.touches[0].clientX, y: e.touches[0].clientY };
  };
  const onTouchMove = (e) => {
    if (!start.current) return;
    const ddx = e.touches[0].clientX - start.current.x;
    const ddy = e.touches[0].clientY - start.current.y;
    if (ddx > 10 && Math.abs(ddx) > Math.abs(ddy) * 1.2) setDx(ddx);
    else if (Math.abs(ddy) > 40 && Math.abs(ddy) > Math.abs(ddx)) { start.current = null; setDx(0); }
  };
  const onTouchEnd = () => {
    if (start.current && dx > 90) onClose();
    start.current = null;
    setDx(0);
  };
  return { dx, handlers: { onTouchStart, onTouchMove, onTouchEnd } };
}
